// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"8bc641d6","731":"4b585068","905":"3ca22e29"}[chunkId] + ".chunk.js";
};